import _ from 'underscore';
import { useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { getIneligibleText, WebsiteValidationStatus } from '../helpers';

export const usePromotionalOfferError = () => {
  const i18n = useContext(I18nContext);
  const couponErrorText = useMemo(() => (
    i18n.getString(_TL_('Sorry we cannot find the provided coupon. Please check if the coupon code is correct or try adding a different coupon code.'))
  ), [i18n]);
  const couponExpiredText = useMemo(() => (
    i18n.getString(_TL_('Promotion has expired. Looks like you don\'t have any active offers right now.'))
  ), [i18n]);

  const GetCouponServerError = useCallback((coupon) => {
    const {
      isAcquisitionCoupon,
      websiteValidationResult,
      isCouponValid,
      couponDetails,
      couponValue,
      isCouponExpired,
    } = coupon;

    const { couponString } = couponValue || {};
    if (_.isEmpty(couponDetails) && _.isEmpty(couponString)) {
      return null;
    }

    if (isAcquisitionCoupon && !_.isNull(websiteValidationResult)
        && websiteValidationResult !== WebsiteValidationStatus.Valid) {
      return getIneligibleText({ websiteValidationResult, i18n });
    }

    if (!couponDetails && !_.isNull(isCouponValid) && !isCouponValid) {
      return couponErrorText;
    }

    if (!_.isNull(isCouponExpired) && isCouponExpired) {
      return couponExpiredText;
    }

    return null;
  }, [couponErrorText, couponExpiredText, i18n]);

  return GetCouponServerError;
};

